import cynthiaSimple from "@/assets/cynthia-simple.webp";
import packDuoAsset from "@/assets/pack-duo.mp4.asset.json";

export interface Product {
  id: string;
  handle: string;
  title: string;
  descriptionHtml: string;
  tags: string[];
  currency: string;
  available: boolean;
  images: Array<{ url: string; altText: string | null }>;
  video?: string;
  /** One-time price in EUR */
  price: number;
  /** Stripe price ID for one-time payment */
  stripePriceId: string;
}

export const PRODUCTS: Product[] = [
  {
    id: "cynthia",
    handle: "cynthia-cynthia",
    title: "Pack Découverte - CynthIA",
    descriptionHtml: `
      <p><strong>Fini le jardinage à l'aveugle.</strong> Le pack parfait pour surveiller une zone clé (salon, terrasse ou potager) et ne plus jamais stresser pour l'arrosage.</p>
      <br/>
      <ul>
        <li>🌿 <strong>Expert Horticole 24/7 :</strong> Une feuille jaune ? Prenez-la en photo, votre expert vous donne le remède instantanément.</li>
        <li>💧 <strong>Anti-Pourrissement :</strong> CynthIA mesure l'humidité exacte à la racine. N'arrosez plus au hasard.</li>
        <li>🔋 <strong>Liberté totale :</strong> 100% étanche (IP67), installation en 2 minutes, fonctionne avec 4 piles AA (8 piles offertes = +400 jours d'autonomie).</li>
      </ul>
      <p style="margin-top: 15px; font-size: 0.9em; color: #059669;"><strong>🛡️ Rentabilisé dès la première plante sauvée.</strong> Garantie Satisfait ou Remboursé 30 jours.</p>
    `,
    tags: [],
    currency: "EUR",
    available: true,
    images: [{ url: cynthiaSimple, altText: "CynthIA - Boîtier jardin intelligent" }],
    price: 89,
    stripePriceId: "price_1TButKPdeWJWOq7xKutoZnEW",
  },
  {
    id: "pack-duo",
    handle: "pack-duo",
    title: "Pack Jardin Complet (Duo)",
    descriptionHtml: `
      <p><strong>Notre Best-Seller.</strong> L'offre ultime pour comparer deux environnements (intérieur vs extérieur) ou couvrir de grands espaces. <strong>La tranquillité d'esprit absolue.</strong></p>
      <br/>
      <ul>
        <li>🔥 <strong>Économie Maximale :</strong> Sauvez plus de 19€ par rapport à deux packs Solo.</li>
        <li>📍 <strong>Gestion Multi-Zones :</strong> Gérez vos deux boîtiers connectés avec une seule application.</li>
        <li>🧠 <strong>Double protection Expert :</strong> Votre expert horticole analyse et croise les données de vos deux zones simultanément.</li>
        <li>🔋 <strong>Piles fournies :</strong> Plus de 400 jours d'autonomie par boîtier.</li>
      </ul>
      <p style="margin-top: 15px; font-size: 0.9em; color: #059669;"><strong>🛡️ Sécurité totale :</strong> Garantie 2 ans et Satisfait ou Remboursé 30 jours. Aucun frais caché.</p>
    `,
    tags: ["bestseller"],
    currency: "EUR",
    available: true,
    images: [{ url: packDuoAsset.url, altText: "Pack Duo CynthIA - 2 boîtiers jardin intelligents" }],
    video: packDuoAsset.url,
    price: 159,
    stripePriceId: "price_1TButLPdeWJWOq7xeWTVgeDj",
  },
];

export function getProductByHandle(handle: string): Product | undefined {
  return PRODUCTS.find((p) => p.handle === handle);
}

export function getAllProducts(): Product[] {
  return PRODUCTS;
}
